import React from "react";
import i18n from "../../../i18n/i18n";
import Button from "../../../common/components/shared/button/button";
import {ReactComponent as DownloadReportIcon} from "../../../statics/icons/icon_downloadReport.svg";
import {Api} from "../../../helpers/api";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import Loader from "../../../common/components/shared/loader/loader";
import Table from "../../../common/components/shared/table/table";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import DownloadReportPopup from "../downloadReportPopup/downloadReportPopup";
import {Utils} from "../../../helpers/utils";

interface ReportSummaryProps {
    onGenerateReport: () => void;
    isReportGenerated: boolean;
    generatedReport: any[] | undefined | null;
    generatedReportResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    reportTestId: string;
    reportHeaders: string[];
    reportProperties: string[];
    reportTableRenderCell?: (row: any, property: string) => JSX.Element;
    reportService: any | undefined;
    className?: string;
    selectedFilters: any;
    currentPage: number;
    numberOfElements: number;
}

interface ReportSummaryState {
    downloadPopupOpen: boolean;
}

export default class ReportSummary extends React.Component <ReportSummaryProps, ReportSummaryState> {
    constructor(props: any) {
        super(props);

        this.state = {
            downloadPopupOpen: false
        };
    }

    public render(): JSX.Element {
        return (
            <div className={`report-summary ${this.props.className}`}>
                {this.props.isReportGenerated && this.renderSummaryReportWrapper()}
            </div>
        );
    }

    private renderHeader(): JSX.Element {
        return (
            <div className="header">
                {i18n.t("reports.generatedSummaryReport")}
                <Button
                    text={i18n.t("reports.downloadSummaryReportButton")}
                    type="primary"
                    variant="outlined"
                    endIcon={<DownloadReportIcon/>}
                    onClick={this.onClickDownload.bind(this)}
                    testId="download-summary-report-button"
                />
            </div>
        );
    }

    private renderSummaryReportWrapper(): JSX.Element {
        if (!Api.isSuccess(this.props.generatedReportResponse)) {
            return (
                <HttpError
                    response={this.props.generatedReportResponse}
                    cause={i18n.t("reports.errors.generateSummaryReportErrorSuffix")}
                />
            );
        } else {
            if (this.props.generatedReport === undefined) {
                return <Loader/>;
            } else {
                return this.renderGeneratedReport();
            }
        }
    }

    private renderGeneratedReport(): JSX.Element {
        const testId = `${this.props.reportTestId}-table`;

        return (
            <div className="generated-summary-report-content content">
                {this.renderHeader()}
                {this.renderDownloadPopup()}
                <div style={{width: Utils.calculateWidthOnTable()}}>
                    {(this.props.generatedReport && this.props.generatedReport.length && this.props.generatedReport.length > 0) ? (
                        <Table
                            headers={this.props.reportHeaders}
                            rows={this.props.generatedReport!}
                            properties={this.props.reportProperties}
                            testId={testId}
                            renderCell={this.props.reportTableRenderCell}
                            currentPage={this.props.currentPage}
                            numberOfElements={this.props.numberOfElements}
                        />
                    ) : (
                        <Table
                            headers={this.props.reportHeaders}
                            rows={[]}
                            properties={this.props.reportProperties}
                            testId={testId}
                            currentPage={0}
                            numberOfElements={0}
                            pageable={false}
                        />
                    )}
                </div>
            </div>
        );
    }

    private renderDownloadPopup() {
        if (this.state.downloadPopupOpen) {
            return <DownloadReportPopup
                reportService={this.props.reportService}
                onCancel={this.onCloseDownloadPopup.bind(this)}
                isSummaryReport={true}
                selectedFilters={this.props.selectedFilters}
            />;
        }
        return <></>;
    }

    private onClickDownload() {
        this.setState({downloadPopupOpen: true});
    }

    private onCloseDownloadPopup() {
        this.setState({downloadPopupOpen: false});
    }
}